import React from 'react'
import { Helmet } from 'react-helmet'
import onLoginSuccess from './modules/on-login-success'
import onCheckoutStateChange from './modules/on-checkout-state-change'
import onCheckoutComplete from './modules/on-checkout-complete'
import isStolApp from '../../../../modules/is-stolapp'
import setCustomVariablesPiano from '../../modules/set-custom-variables-piano'
import isServerSide from '../../../../modules/is-server-side'
import consoleLogger from '../../../../modules/console-logger'

const TPInitialize = () => {
  if (!isServerSide()) {
    const [consoleLog] = new consoleLogger('InitPiano')
    window.tp = window['tp'] || []
    window.tp.push(['setAid', process.env.RAZZLE_SPLUS_PIANO_APP_ID])
    consoleLog('AID', process.env.RAZZLE_SPLUS_PIANO_APP_ID)
    if (process.env.RAZZLE_ENVIRONMENT === 'staging') {
      window.tp.push(['setSandbox', true])
      window.tp.push(['setDebug', true])
      window.tp.push(['setEndpoint', 'https://sandbox.tinypass.com/api/v3'])
    } else {
      window.tp.push(['setEndpoint', 'https://buy.tinypass.com/api/v3'])
    }
    window.tp.push(['setUsePianoIdUserProvider', true])
    window.tp.push(['setCustomVariable', 'isStolApp', isStolApp()])
    window.tp.push(['setUseTinypassAccounts', false])

    window.tp.push([
      'init',
      function () {
        consoleLog('LOADED', '')
        // Tell Scheduler Piano is Ready
        window.callbackFunction('pianoLoaded')
      },
    ])

    setCustomVariablesPiano()
    onCheckoutStateChange()
    onLoginSuccess()
    onCheckoutComplete()
  }
  return (
    <Helmet>
      <script type="text/javascript" async="" src="//cdn.tinypass.com/api/tinypass.min.js"></script>
    </Helmet>
  )
}

export default TPInitialize
